// extracted by mini-css-extract-plugin
export default {"icon-button":"mAZF70It--IconButton_icon-button__avoZ-","iconButton":"mAZF70It--IconButton_icon-button__avoZ-"};